module.exports = __webpack_public_path__ + "8a8aaa5eec1c6a22be8e8984718282d9.fbx";